import { Print, Refresh, ThumbDown, ThumbUp } from "@mui/icons-material";
import {
	Box,
	Button,
	FormControl,
	FormControlLabel,
	Paper,
	Radio,
	RadioGroup,
	TextField,
	Typography,
	Zoom,
} from "@mui/material";

const PrescriptionPreview = ({ age, gender, advice, creation_date }) => {
	const handlePrint = (record) => {
		// Create a formatted print content
		const newWindow = window.open("", "", "width=800,height=600");
		newWindow.document.write(`
      <html>
        <head>
          <title>স্বাস্থ্য উপদেশ</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              padding: 20px;
              max-width: 800px;
              margin: 0 auto;
              color: #333;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #3b82f6;
            }
            h2 { 
              color: #1e40af; 
              margin-bottom: 5px;
            }
            .patient-info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
              background: #f0f9ff;
              padding: 10px;
              border-radius: 5px;
            }
            .section {
              margin-bottom: 20px;
            }
            .section-title {
              color: #3b82f6;
              border-bottom: 1px solid #ddd;
              padding-bottom: 5px;
              margin-bottom: 10px;
            }
            ul { 
              list-style-type: disc; 
              margin-left: 20px; 
              padding-left: 15px;
            }
            li {
              padding: 5px 0;
            }
            .footer {
              margin-top: 30px;
              padding-top: 10px;
              border-top: 1px solid #ddd;
              font-style: italic;
              font-size: 12px;
              color: #666;
            }
            .note {
              background: #f9f9f9;
              padding: 10px;
              border-left: 3px solid #3b82f6;
              margin-top: 20px;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>স্বাস্থ্য উপদেশ</h2>
            <p>তারিখ: ${new Date().toLocaleDateString()}</p>
          </div>
          
          <div class="patient-info">
            <div>
              <strong>বয়স:</strong> ${record.age} বছর
            </div>
            <div>
              <strong>লিঙ্গ:</strong> ${
					record.gender === "male"
						? "পুরুষ"
						: record.gender === "female"
						? "মহিলা"
						: record.gender === "other"
						? "অন্যান্য"
						: ""
				}
            </div>
          </div>
          
          <div class="section">
            <h3 class="section-title">পরীক্ষা সমূহ:</h3>
            <ul>
              ${record.advice?.diagnostic_test_list
					?.map((test) => `<li>${test}</li>`)
					.join("")}
            </ul>
          </div>
          
          <div class="section">
            <h3 class="section-title">ঔষধ সমূহ:</h3>
            <ul>
              ${record.advice?.medicine_list
					?.map((med) => `<li>${med}</li>`)
					.join("")}
            </ul>
          </div>
          
          <div class="section">
            <h3 class="section-title">পরামর্শ:</h3>
            <ul>
              ${record.advice?.advice_list
					?.map((advice) => `<li>${advice}</li>`)
					.join("")}
            </ul>
          </div>
          
          <div class="note">
            <p><sup>1.</sup> এটি একটি প্রাথমিক রূপরেখা। রেজিস্টার্ড ডাক্তারের পরামর্শ নিয়ে ওষুধ সেবন করুন।</p>
          </div>
        </body>
      </html>
    `);

		newWindow.document.close();
		newWindow.focus();
		setTimeout(() => {
			newWindow.print();
			newWindow.close();
		}, 500);
	};
	return (
		<Box className="max-w-2xl mx-auto">
			<Zoom in={true}>
				<Paper
					className="bg-blue-50 rounded-lg shadow-md"
					elevation={0}
				>
					<Box className="bg-white p-2 rounded-lg">
						<div className="text-center mb-5 pb-2 border-b-2 border-blue-500">
							<h2 className="text-[#1e40af] mb-1 text-2xl font-bold">
								স্বাস্থ্য উপদেশ
							</h2>
							<p>
								{"তারিখ: "}
								{new Date(creation_date).toLocaleDateString()}
							</p>
						</div>

						<div className="flex justify-between mb-5 bg-blue-50 p-2.5 rounded-md">
							<div>
								<strong>{"বয়স: "}</strong>
								{age} বছর
							</div>
							<div>
								<strong>{"লিঙ্গ: "}</strong>
								{gender === "male"
									? "পুরুষ"
									: gender === "female"
									? "মহিলা"
									: gender === "other"
									? "অন্যান্য"
									: ""}
							</div>
						</div>

						<Box className="mt-4">
							<Typography
								variant="h6"
								className="font-semibold mb-2 text-blue-600 border-b border-gray-200 pb-1"
							>
								পরীক্ষা সমূহ:
							</Typography>
							<ul className="list-disc ml-6 mt-3">
								{advice?.diagnostic_test_list?.map(
									(test, index) => (
										<li
											key={index}
											className="py-1 text-gray-800"
										>
											{test}
										</li>
									)
								)}
							</ul>
						</Box>

						<Box className="mt-4">
							<Typography
								variant="h6"
								className="font-semibold mb-2 text-blue-600 border-b border-gray-200 pb-1"
							>
								ঔষধ সমূহ:
							</Typography>
							<ul className="list-disc ml-6 mt-3">
								{advice?.medicine_list?.map((med, index) => (
									<li
										key={index}
										className="py-1 text-gray-800"
									>
										{med}
									</li>
								))}
							</ul>
						</Box>

						<Box className="mt-4">
							<Typography
								variant="h6"
								className="font-semibold mb-2 text-blue-600 border-b border-gray-200 pb-1"
							>
								পরামর্শ:
							</Typography>
							<ul className="list-disc ml-6 mt-3">
								{advice?.advice_list?.map((advice, index) => (
									<li
										key={index}
										className="py-1 text-gray-800"
									>
										{advice}
									</li>
								))}
							</ul>
						</Box>

						{/* Feedback Section */}

						<Box className="flex flex-wrap gap-4 mt-6 items-center justify-center">
							<Button
								variant="contained"
								color="primary"
								onClick={() =>
									handlePrint({ age, gender, advice })
								}
								className="bg-blue-600 hover:bg-blue-700"
								startIcon={<Print />}
							>
								উপদেশ প্রিন্ট করুন
							</Button>
						</Box>
						<Box className="mt-8 p-4 bg-gray-100 rounded-lg border border-gray-300">
							<Typography
								variant="body2"
								className="text-gray-700 italic"
							>
								<sup>1.</sup> এটি একটি প্রাথমিক রূপরেখা।
								রেজিস্টার্ড ডাক্তারের পরামর্শ নিয়ে ওষুধ সেবন
								করুন।
							</Typography>
						</Box>
					</Box>
				</Paper>
			</Zoom>
		</Box>
	);
};

export default PrescriptionPreview;
